// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603270955/js/" + chunkId + "." + {"44":"90ccc7d4","225":"24f470fe","481":"b6b8d630","486":"adf60ad7","770":"ff0da050"}[chunkId] + ".0.6709721902225592.chunk.js";
};